/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Empty_Body_CoachInputs */

const en_blog_empty_body_coach = /** @type {(inputs: Blog_Empty_Body_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're writing about programming, keeping clients and growing a coaching business. Start free and read them first.`)
};

const pl_blog_empty_body_coach = /** @type {(inputs: Blog_Empty_Body_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piszemy o programowaniu treningu, zatrzymywaniu podopiecznych i rozwoju działalności. Zacznij za darmo i czytaj pierwszy.`)
};

/**
* | output |
* | --- |
* | "We're writing about programming, keeping clients and growing a coaching business. Start free and read them first." |
*
* @param {Blog_Empty_Body_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_empty_body_coach = /** @type {((inputs?: Blog_Empty_Body_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Empty_Body_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_empty_body_coach(inputs)
	return en_blog_empty_body_coach(inputs)
});